import { ReactElement } from 'react'
import { InputEvent } from 'typings/custom'
import TextField from 'syf-component-library/ui/atoms/Textfield'
import { FA_SEARCH } from 'const/icons'
import { SearchIcon, SwitchSearchContainer } from './subcomponents'
import { SwitchAccountSearchProps } from './typing'

const SwitchAccountSearch = ({
  searchAccount,
  searchVal = ''
}: SwitchAccountSearchProps): ReactElement => {
  return (
    <SwitchSearchContainer>
      <TextField
        id="username"
        autoCapitalize="none"
        name="username"
        placeholder="Search by Account Name"
        leftIcon={<SearchIcon name={FA_SEARCH} />}
        type="text"
        value={searchVal}
        onChange={({ target: { value } }: InputEvent): void => {
          searchAccount(value)
        }}
      />
    </SwitchSearchContainer>
  )
}

export default SwitchAccountSearch
